import ContentHeader from "src/widgets/contentHeader/ContentHeader";
import { useTransportInfo } from "./hooks/useTransportInfo";
import { transportInfoCardStructure as cardStructure } from './structure';
import ToastMessageContainer from "src/widgets/toastMessageContainer/ToastMessageContainer";
import { CardInfoSection } from "src/widgets/cards/CardInfoSection";
import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import TransportHistoryObjectDrivewaysTable from "src/widgets/transport/transportHistoryObjectDrivewaysTable/TransportHistoryObjectDrivewaysTable";
import { useDispatch } from "react-redux";
import { showToastMessage } from "src/stateManagement/reducers";

export default function TransportInfoCard() {
    const dispatch = useDispatch();
    const { cardType } = useParams<{ cardType: "now" | "history" }>();
    const shouldRenderTransportDriveways = cardType === "history";
    const [cardName, setCardName] = useState<string>('')
    const { data: transportInfo, isLoadingMainData, isError: isTransportInfoError } = useTransportInfo()

    useEffect(() => {
        if (transportInfo?.stateNumber) {
            const caption = cardType === "history" ? "История движений транспортного средства" : "Транспортное средство"
            setCardName(`${caption} ${transportInfo.stateNumber}`);
        }
    }, [transportInfo, cardType]);

    useEffect(() => {
        if (isTransportInfoError) {
            dispatch(showToastMessage({ messageText: "Не удалось загрузить информацию о транспорте", messageType: "error" }))
        }
    }, [isTransportInfoError])

    return (
        <>
            <ContentHeader title={cardName} />
            <div className="card-div user-info-card-div">
                <ToastMessageContainer />
                {cardStructure.map((sectionOptions: any) =>
                    <CardInfoSection
                        sectionOptions={sectionOptions}
                        data={transportInfo}
                        isLoadingMainData={isLoadingMainData}
                    />
                )}
                {shouldRenderTransportDriveways && <TransportHistoryObjectDrivewaysTable />}
            </div>
        </>
    )
}
